type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
};

export default function SectionHeading({ eyebrow, title, subtitle, align = 'left' }: SectionHeadingProps) {
  const alignClass = align === 'center' ? 'items-center text-center mx-auto' : 'items-start text-left';
  return (
    <div className={`flex max-w-3xl flex-col ${alignClass}`}>
      {eyebrow && (
        <span className="mb-3 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600">
          <span className="h-px w-6 bg-accent-500" />
          {eyebrow}
        </span>
      )}
      <h2 className="text-balance font-heading text-2xl font-semibold leading-tight text-foreground-950 md:text-[34px]">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{subtitle}</p>}
    </div>
  );
}